import React, {useState, useEffect, useRef} from 'react'
import VideoCarouselItem from './VideoCarouselItem'
import classes from './VideoCarousel.module.scss'
import ProgressIndicator from './ProgressIndicator'
import ProgressBar from './VideoCarouselItem/ProgressBar'
import globalJSON from 'data/global.json'


function VideoCarousel({content, onItemSelection}){

	const [currentSlide, setCurrentSlide] = useState(0);

	const [carouselZIndexes, setCarouselZIndexes] = useState([])
	let previousSlide = useRef(0)
	let timeoutLengthSeconds = 10

	function showNext(){
		let nextSlide = currentSlide+1 
		if(content[nextSlide]){
			setCurrentSlide(nextSlide);
		}else{
			setCurrentSlide(0);
		}
	}

	useEffect(() => {

		let zIndexes = [];
		for (let index = 0; index < content.length; index++) {
			zIndexes[index] = 0
		}
		zIndexes[previousSlide.current] = 1
		zIndexes[currentSlide] = 2
		setCarouselZIndexes(zIndexes)
		previousSlide.current = currentSlide

	},[currentSlide])

	function onRadioButtonPress(index){
		setCurrentSlide(index);
	}

	function shouldIndexPreload(index){

		let shouldPreload = false;
		let indexDiff = currentSlide - index
		
		if(index === currentSlide){
		  shouldPreload = true
		}
		if(indexDiff === 1 || indexDiff === -1){
		  shouldPreload = true
		}
		if(currentSlide === 0 && index === content.length-1){
		  shouldPreload = true
		}
		if(currentSlide === content.length-1 && index === 0){
		  shouldPreload = true
		}
		return shouldPreload
	}

	return (

		<>
			{content.map((element, index) => {
				return (
					<section style={{zIndex:carouselZIndexes[index]}} className={`${classes.VideoCarousel__itemWrap}`} key={index}>
						<VideoCarouselItem 
							onPlayPress={() => {onItemSelection(index)}}
							isActive={(currentSlide === index)} 
							shouldPreload={shouldIndexPreload(index)} 
							onTimeoutComplete={() => {showNext()}}
							timeoutLengthSeconds={timeoutLengthSeconds} 
							content={element}
							videoCdnUrl={globalJSON.videoCdn}/>
					</section>
				)
			})}
			<section className={`${classes.VideoCarousel__progressWrap}`}>
				<ProgressIndicator onPress={(index) => {onRadioButtonPress(index)}} currentIndex={currentSlide} itemcount={content.length}/>
			</section>
		</>
		
	)
}

export default VideoCarousel